import React, { useEffect, useState } from "react";
import constructQuizResponse, { extractTags, getFormData } from "../../../../utils/constructQuizResponse";
import { useTranslation } from "react-i18next";
import useSubmitQuizResponse from "../../../../services/useSubmitQuizResponse";
import { postAppEvent } from "../../../../services/appEvent";
import { addQueryParams } from "../../../../utils/addQueryParams";

type ThankyouProps = {
    question: {
        helpText: string;
        type: string;
        _id: string;
        imgUrl: string;
        questionText: string;
    };
    userResponse: Array<{
        questionType: string;
        nextQuestionId: string;
        _id: string;
        action?: string;
        answerResponse: Array<object>;
        selfieResponse: Array<object>;
        selfieID: string;
        userSelfie: string;
    }>;
    sessionID: string;
    quiz: {
        quizRedirectDelay: string
    };
    params: object;
};

const Thankyou: React.FC<ThankyouProps> = ({ question, userResponse, inputs, sessionID, quiz, params }) => {
    const { t } = useTranslation();
    const { mutate, isSuccess, data } = useSubmitQuizResponse()
    const [delayTimeOut, setDelayTimeOut] = useState(false)

    useEffect(() => {
        mutate(constructQuizResponse(userResponse, params.formId, params.shopId, quiz));
        let submitEvent = {
            attributes: {
                form: getFormData(userResponse),
                tags: extractTags(userResponse)
            },
            event_name: "submit_quiz",
            event_timestamp: new Date().getTime(),
            event_type: "click",
            page_uri: `/quiz/${question.quizId}/summary`,
        }
        postAppEvent({ sessionId: sessionID, inAppEvent: [submitEvent] })
    }, [mutate])

    useEffect(() => {
        if (quiz.quizRedirectDelay) {
            const timeoutId = setTimeout(() => setDelayTimeOut(true), Number(quiz.quizRedirectDelay));
            return () => clearTimeout(timeoutId); // Clean up timeout.
        }
    }, [quiz.quizRedirectDelay]);

    if (isSuccess && (!quiz.quizRedirectDelay || delayTimeOut)) {
        const recoURL = quiz.meta.recoUrl;
        const postSubmitEvent = {
            attributes: {
                resp_id: data.resp_id
            },
            event_name: "submit_quiz_success",
            event_type: "api",
            event_timestamp: new Date().getTime(),
            page_uri: `/quiz/${question.quizId}/summary`,
        }
        postAppEvent({ sessionId: sessionID, inAppEvent: [postSubmitEvent] })
        if (recoURL && recoURL != "/") {
            window.location.href = addQueryParams(recoURL, "resp_id", data.resp_id);
        }
    }

    return (
        <div className={"tangent_summary_screen_custom tangent_summary_screen_mob_custom tngnt-flex tngnt-flex-col tngnt-items-center tngnt-gap-4 sm:tngnt-gap-6 tngnt-p-3 sm:tngnt-p-6 tngnt-justify-center tngnt-w-[100%] tngnt-h-[500px]"} id={`comp_${question._id}`}>
            <div className='tangent_global_style tangent_question_text tangent_summary_text_custom tangent_summary_text__mob_custom tngnt-text-center tngnt-text-[20px] tngnt-ml-[15px] tngnt-mr-[15px]' dangerouslySetInnerHTML={{ __html: eval('`' + question.questionText + '`') }} />
            {question.imgUrl ? <img className='tangent_summary_image_custom tangent_summary_image_mob_custom tngnt-max-w-[400px] tngnt-max-h-[300px] sm:tngnt-max-w-[500px] sm:tngnt-max-h-[400px]' src={question.imgUrl} alt='question image' /> : null}
            <div className="tngnt-flex">
                <span className="tangent_global_style tangent_loading_text_custom tangent_loading_text_mob_custom tngnt-border-solid tngnt-text-[15px]">{t('loading')}&nbsp;</span>
                <span className='tngnt-animate-bounce [animation-delay:-0.4s]'>.</span>
                <span className='tngnt-animate-bounce [animation-delay:-0.3s]'>.</span>
                <span className='tngnt-animate-bounce [animation-delay:-0.2s]'>.</span>
                <span className='tngnt-animate-bounce [animation-delay:-0.1s]'>.</span>
                <span className='tngnt-animate-bounce'>.</span>
            </div>
            {
                question?.helpText && <div className="tangent_global_style tangent_global_style_custom tangent_helpText_custom tngnt-p-2 tngnt-mt-6 tngnt-text-[14px] tngnt-leading-[20px]" dangerouslySetInnerHTML={{ __html: eval('`' + question.helpText + '`') }}></div>
            }
        </div >
    )
}

export default Thankyou